import React, { useEffect, useState } from "react";
import Modal from 'react-bootstrap/Modal';
import { validatorTypes } from "@data-driven-forms/react-form-renderer";
import FormRenderer, { ComponentMapper, FormTemplate, componentTypes } from "../../../common/FormRenderer";
import { Button } from "react-bootstrap";
import { ACTIONS } from "../../../common/Constants";
import { getValue } from "../../../../utils/common";
import { ActivityType, CalendarType, GetActionTitle, Periodicity } from "../Master.constants";

function ActivityDetails({ action, record : data, onClose, onSubmit }: any) {
    const [activity, setActivity] = useState<any>({ hideButtons: true })

    const schema = {
        fields: [
            {
                component: componentTypes.PLAIN_TEXT,
                name: 'name',
                label: 'Activity',
                validate: [
                    { type: validatorTypes.REQUIRED }
                ],
                content: getValue(activity, 'name')
            },
            {
                component:componentTypes.PLAIN_TEXT,
                name: 'type',
                label: 'Activity Type',
                options: ActivityType.map(x => {
                    return { id: x, name: x };
                }),
                validate: [
                    { type: validatorTypes.REQUIRED }
                ],
                content: getValue(activity, 'type.label')
            },
            {
                component: componentTypes.PLAIN_TEXT,
                name: 'periodicity',
                label: 'Periodicity',
                options: Periodicity.map(x => {
                    return { id: x, name: x };
                }),
                validate: [
                    { type: validatorTypes.REQUIRED }
                ],
                content: getValue(activity, 'periodicity.label')
            },
            {
                component: componentTypes.PLAIN_TEXT,
                name: 'calendarType',
                label: 'Calendar Type',
                options: CalendarType.map(x => {
                    return { id: x, name: x };
                }),
                validate: [
                    { type: validatorTypes.REQUIRED }
                ],
                content: getValue(activity, 'calendarType.label')
            }
        ]
    };

    useEffect(() => {
        if (data) {
            const { name, activity_type, periodicity, calendar_type } = data;
            setActivity({
                ...activity,
                name,
                type: activity_type ? { value: activity_type, label: activity_type } : null,
                periodicity: periodicity ? { value: periodicity, label: periodicity } : null,
                calendarType: calendar_type ? { value: calendar_type, label: calendar_type } : null
            });
        }
    }, [data]);

    return (
        <Modal show={true} backdrop="static" dialogClassName="drawer" animation={false}>
            <Modal.Header closeButton={true} onHide={onClose}>
                <Modal.Title className="bg">{GetActionTitle('Activity', action)}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <FormRenderer FormTemplate={FormTemplate}
                    initialValues={activity}
                    componentMapper={ComponentMapper}
                    schema={schema}
                />
            </Modal.Body>
            <Modal.Footer className="d-flex justify-content-between">
                {
                    
                    <Button variant="primary" onClick={onClose} className="px-4 ms-auto">{'Close'}</Button>

                }
            </Modal.Footer>
        </Modal>
    )
}

export default ActivityDetails;
